import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'find',
    standalone: false
})
export class FindPipe implements PipeTransform {
  transform(list: any, key: any, value: any): any {
    return list?.find(l => {
      const listValue = l[key];
      if (Array.isArray(listValue)) {
        return listValue.includes(value);
      } else {
        return l[key] === value;
      }
    });
  }
}
